module.exports = __webpack_public_path__ + "img/rcastellum64_ua.b0eed3b3.webp";